import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { getAllTopics } from "../helper/apicalls/topic";
import { getMaterialFolders, getMaterialInstitutionFolders } from "../helper/apicalls/materials";
import MaterialFolderGrid from "../components/MaterialFolderGrid";
import "../styles/MaterialFolder.scss";

const MaterialsSubject = () => {
  const { coursekey, subjectkey } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const initialTab = searchParams.get("tab") || "course";
  const [activeTab, setActiveTab] = useState(initialTab);

  const [courseFolders, setCourseFolders] = useState([]);
  const [institutionFolders, setInstitutionFolders] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        let topicsRes = [];
        let materialsRes = [];
        let instMaterialsRes = [];

        try {
          topicsRes = await getAllTopics(subjectkey);
        } catch (e) {
          console.error("Failed to fetch topics:", e);
        }

        try {
          materialsRes = await getMaterialFolders({ title: "subject", key: subjectkey || "" });
        } catch (e) {
          console.error("Failed to fetch subject materials:", e);
        }

        try {
          instMaterialsRes = await getMaterialInstitutionFolders({ title: "subject", key: subjectkey || "" });
        } catch (e) {
          console.error("Failed to fetch subject institution materials:", e);
        }

        const topics = Array.isArray(topicsRes) ? topicsRes : [];
        const materials = Array.isArray(materialsRes?.data)
          ? materialsRes.data
          : Array.isArray(materialsRes)
          ? materialsRes
          : [];
        const instMaterials = Array.isArray(instMaterialsRes?.data)
          ? instMaterialsRes.data
          : Array.isArray(instMaterialsRes)
          ? instMaterialsRes
          : [];

        const topicFolders = topics.map((t) => ({ ...t, _kind: "topic" }));
        const courseMaterialFolders = materials.map((m) => ({
          ...m,
          _kind: "material",
        }));
        const institutionMaterialFolders = instMaterials.map((m) => ({
          ...m,
          _kind: "institution_material",
        }));

        setCourseFolders([...topicFolders, ...courseMaterialFolders]);
        setInstitutionFolders([...topicFolders, ...institutionMaterialFolders]);
      } catch (e) {
        console.error("Failed to load materials for subject", e);
        setCourseFolders([]);
        setInstitutionFolders([]);
      } finally {
        setLoading(false);
      }
    };

    if (subjectkey) {
      fetchData();
    }
  }, [subjectkey]);

  const handleOpenFolder = (folder) => {
    if (!folder) return;
    if (folder._kind === "topic" && folder.key) {
      navigate(`/materials/${coursekey}/${subjectkey}/${folder.key}?tab=${activeTab}`);
      return;
    }
    if (folder._kind === "material" && (folder.id || folder._id)) {
      const folderId = folder.id || folder._id;
      navigate(`/materials-folder/${folderId}`);
      return;
    }
    if (folder._kind === "institution_material" && (folder.id || folder._id)) {
      const folderId = folder.id || folder._id;
      navigate(`/materials-folder/${folderId}?type=institution`);
      return;
    }
  };

  const currentFolders = activeTab === "institution" ? institutionFolders : courseFolders;

  return (
    <div className="materials-page">
      <div className="materials-header">
        <h1 className="materials-title">Materials - Topics</h1>
      </div>

      <div className="materials-tabs">
        <button
          type="button"
          className={`materials-tab ${activeTab === "course" ? "active" : ""}`}
          onClick={() => setActiveTab("course")}
        >
          Course Resources
        </button>
        <button
          type="button"
          className={`materials-tab ${activeTab === "institution" ? "active" : ""}`}
          onClick={() => setActiveTab("institution")}
        >
          Institution Resources
        </button>
      </div>

      {loading ? (
        <div className="materials-loading">Loading materials...</div>
      ) : (
        <MaterialFolderGrid folders={currentFolders} onOpen={handleOpenFolder} />
      )}
    </div>
  );
};

export default MaterialsSubject;
